export enum PlayerCardStatus {
    none = "none",
    red = "red",
    yellow = "yellow",
}
